import { Interp } from '../../lib/render.jsx';

export default function DmInbox({ v }) {
  if (!v.showDmInbox) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "97", "padding": "20px" }} onClick={v.dismissDm}>
        <div className="gp-venster gp-vast" style={{ "position": "relative", "overflow": "hidden", "width": "min(400px,100%)" }} onClick={v.stopProp}>
          {' '}
          <div style={{ "position": "absolute", "top": "0", "bottom": "0", "left": "20px", "width": "42px", "background": "linear-gradient(90deg,#4a494f 0% 6%,#74737c 6% 16%,#9f9ea4 16% 27%,#c7c6c9 27% 38%,#e6e6e7 38% 47%,#f5f5f5 47% 53%,#e6e6e7 53% 62%,#c7c6c9 62% 73%,#9f9ea4 73% 84%,#74737c 84% 94%,#4a494f 94% 100%)", "boxShadow": "inset 10px 0 10px -10px rgba(30,26,48,.4),inset -10px 0 10px -10px rgba(30,26,48,.4)" }} />
          {' '}
          <div style={{ "position": "absolute", "top": "18px", "left": "30px", "width": "22px", "height": "22px", "transform": "rotate(-7deg)", "background": "var(--geel)" }} />
          {' '}
          <div style={{ "position": "absolute", "top": "60px", "left": "26px", "width": "22px", "height": "22px", "transform": "rotate(5deg)", "background": "#29ADFF" }} />
          {' '}
          <div style={{ "position": "absolute", "top": "102px", "left": "33px", "width": "22px", "height": "22px", "transform": "rotate(-3deg)", "background": "#FF004D" }} />
          {' '}
          <div style={{ "position": "absolute", "top": "144px", "left": "27px", "width": "22px", "height": "22px", "transform": "rotate(7deg)", "background": "var(--groen)" }} />
          {' '}
          <div style={{ "position": "absolute", "top": "186px", "left": "31px", "width": "22px", "height": "22px", "transform": "rotate(-5deg)", "background": "var(--geel)" }} />
          {' '}
          <div style={{ "position": "relative", "padding": "22px 22px 22px 80px", "display": "flex", "flexDirection": "column", "gap": "18px" }}>
            <div style={{ "display": "flex", "flexDirection": "column", "gap": "9px" }}>
              <div style={{ "display": "flex", "alignItems": "baseline", "gap": "8px" }}>
                <span style={{ "fontSize": "19px", "fontWeight": "700" }}>
                  Krabbelpaal XP
                </span>
                <span style={{ "fontSize": "11px", "fontWeight": "600", "color": "var(--tekst-3)" }}>
                  <Interp v={v.dmWhen} />
                </span>
              </div>
              <div style={{ "position": "relative", "background": "var(--lila)", "border": "3px solid var(--ink)", "borderRadius": "16px", "boxShadow": "3px 3px 0 var(--ink)", "padding": "14px 15px" }}>
                {' '}
                <span style={{ "position": "absolute", "left": "-16px", "top": "16px", "width": "0", "height": "0", "borderTop": "10px solid transparent", "borderBottom": "10px solid transparent", "borderRight": "14px solid var(--ink)" }} />
                {' '}
                <span style={{ "position": "absolute", "left": "-10px", "top": "20px", "width": "0", "height": "0", "borderTop": "6px solid transparent", "borderBottom": "6px solid transparent", "borderRight": "11px solid var(--lila)" }} />
                {' '}
                <div style={{ "position": "relative", "fontSize": "15px", "fontWeight": "600", "lineHeight": "1.4", "whiteSpace": "pre-wrap", "overflowWrap": "anywhere", "textWrap": "pretty" }}>
                  <Interp v={v.dmMessage} />
                </div>
                {' '}
              </div>
            </div>
            <div style={{ "display": "flex", "alignItems": "center", "justifyContent": "flex-end" }}>
              <button onClick={v.dismissDm} className="gp-btn pink" style={{ "flex": "0 0 auto" }}>
                <Interp v={v.dmDismissLabel} />
              </button>
            </div>
          </div>
          {' '}
        </div>
      </div>
      {' '}
    </>
  );
}
